import { Component } from '@angular/core';

@Component({
	selector: 'app-definitions',
	templateUrl: './definitions.component.html',
	styleUrls: ['./definitions.component.css'],
})
export class DefinitionsComponent {
	constructor() {}
}
